import { render, staticRenderFns } from "./products.vue?vue&type=template&id=04aca81d&scoped=true"
import script from "./products.vue?vue&type=script&lang=js"
export * from "./products.vue?vue&type=script&lang=js"
import style0 from "./products.vue?vue&type=style&index=0&id=04aca81d&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aca81d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04aca81d')) {
      api.createRecord('04aca81d', component.options)
    } else {
      api.reload('04aca81d', component.options)
    }
    module.hot.accept("./products.vue?vue&type=template&id=04aca81d&scoped=true", function () {
      api.rerender('04aca81d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/terminal_info/form/components/products/products.vue"
export default component.exports